module.exports = __webpack_public_path__ + "img/中国足协@2x.ec5f948e.png";